module.exports = __webpack_public_path__ + "img/eye_colored.98f8ba85.svg";